<template>
  <div class="news-list">
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>查詢</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form>
                <v-row align="center">
                  <v-col cols="12" md="2">
                    <DateRange label="開始日期" v-model="searchForm.startDate" />
                  </v-col>
                  <v-col cols="12" md="2">
                    <DateRange label="結束日期" v-model="searchForm.endDate" />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select :items="mediaList" label="媒體" v-model="searchForm.mediaId"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field label="標題" v-model="searchForm.title"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" align="right">
                    <v-btn class="ma-2" :loading="loading" @click="handleSerach"
                    >查詢</v-btn
                    >
                    <v-btn class="ma-2" @click="handleClear">清除</v-btn>
                  </v-col>
                </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row style="margin-top:5px;">
      <v-col cols="12" md="10"></v-col>
      <v-col cols="12" md="2" style="text-align: right">
        <v-icon @click="handleCreate">mdi-plus</v-icon>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col v-for="item in news" :key="item.id" cols="12" md="3">
        <v-card>
          <v-img
            :src="item.newsPic"
            height="200px"
          ></v-img>
          <v-card-subtitle class="pb-0 pt-0">
            {{ item.newsDate | date }}
          </v-card-subtitle>
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <v-card-subtitle >
            <img class="news-list__image" :src="item.mediaLogo"/>
            {{ item.mediaName }}
          </v-card-subtitle>
          <v-card-text class="text--primary">
            <div class="news-list__content">
              {{ item.newsContent }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn icon @click="handleEdit(item.newsId)"><v-icon>mdi-lead-pencil</v-icon></v-btn>
            <v-btn icon @click="handleDelete(item.newsId)"><v-icon>mdi-window-close</v-icon></v-btn>
            <v-btn text @click="handleWatchReport(item.newsLink)">完整報導</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '@/api';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';
import Swal from 'sweetalert2';

// const defaultPage = {
//   pageSize: 10,
//   pageNo: 1,
// };

export default {
  components: {
    DateRange,
  },
  data() {
    return {
      panel: 0,
      loading: false,
      deleteId: 0,
      searchForm: {
        startDate: this.$route.query.startDate ? this.$route.query.startDate : '',
        endDate: this.$route.query.endDate ? this.$route.query.endDate : '',
        title: this.$route.query.title ? this.$route.query.title : '',
        mediaId: this.$route.query.mediaId ? this.$route.query.mediaId : '',
      },
      mediaList: [],
      mediaType: [],
      news: [],
      page: {
        pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 10,
        pageNo: this.$route.query.pageNo ? this.$route.query.pageNo : 1,
      },
    };
  },
  filters: {
    date(value) {
      return moment(value).format('YYYY-MM-DD');
    },
  },
  created() {
    this.getNewsList();
    this.getMediaList();
  },
  methods: {
    async getMediaList() {
      const { data } = await api.media.mediaList();
      this.mediaType = data;
      this.mediaList = this.mediaType.map((type) => type.mediaName);
    },
    async getNewsList() {
      const params = {
        ...this.removeEmptyValue(this.page),
        ...this.removeEmptyValue(this.searchForm),
      };
      if (params.mediaId) {
        params.mediaId = this.getMediaId(params.mediaId);
      }

      const { data: { totalCount = 0, data: newsClasses = [] } } = await api.news.newsList(params);
      this.totalCount = totalCount;
      this.news = newsClasses || [];
    },
    handleSerach() {
      this.loading = true;
      this.page.pageNo = 1;
      this.$router.replace({ query: null });
      this.getNewsList();
      this.loading = false;
    },
    getMediaId(mediaName) {
      const matchMedia = this.mediaType.filter((type) => type.mediaName === mediaName)[0];
      return matchMedia ? matchMedia.mediaId : '';
    },
    getMediaName(mediaId) {
      const matchMedia = this.mediaType.filter((type) => type.mediaId === mediaId)[0];
      return matchMedia ? matchMedia.mediaName : '';
    },
    removeEmptyValue(object) {
      const newObj = {};
      Object.keys(object).forEach((key) => {
        if (!(object[key] === '' || object[key] === undefined || object[key] === null)) {
          newObj[key] = object[key];
        }
      });
      return newObj;
    },
    handleClear() {
      this.searchForm = {
        startDate: '',
        endDate: '',
        title: '',
        mediaId: '',
      };
      this.$router.replace({ query: null });
      this.getNewsList();
    },
    async handleDelete(newsId) {
      await Swal.fire(
        {
          title: '確定要刪除此新聞嗎?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.news.delete(newsId);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            this.getNewsList();
          } else {
            await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
          }
        }
      });
    },
    handleEdit(newsId) {
      this.$router.push({ name: 'news-edit', params: { newsId }, query: { ...this.page, ...this.searchForm } });
    },
    handleCreate() {
      this.$router.push({ name: 'news-create', query: { ...this.page, ...this.searchForm } });
    },
    handleWatchReport(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.news-list {
  &__content {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &__image {
    width: 32px;
  }
}
</style>
